// src/components/citiesData.js

export const saudiCities = {
  "الرياض": [
    "النرجس",
    "العليا",
    "الملز",
    "النسيم",
    "الروضة",
    "الربوة",
    "المرسلات",
    "الصحافة",
    "العزيزية",
    "الملقا",
    "النخيل",
    "الياسمين",
    "الرحمانية",
    "الورود",
    "المروج",
    "الغدير",
    "الربيع",
    "النهضة",
    "الازدهار",
    "السليمانية",
    "المغرزات",
    "العقيق",
    "المروة",
    "الفلاح",
    "النفل"
  ],
  "جدة": [
    "البوادي",
    "الصفا",
    "المروة",
    "النزهة",
    "الفيصلية",
    "الروضة",
    "الحمراء",
    "السلامة",
    "البساتين",
    "الربوة",
    "الشرفية",
    "النعيم",
    "النهضة",
    "الفضل",
    "الكندرة",
    "العزيزية",
    "مشرفة",
    "الرحاب",
    "الواحة",
    "الأندلس",
    "الأجاويد",
    "السنابل",
    "الهدي",
    "السامر",
    "الأمير عبد المجيد",
    "الأمير فواز",
    "الجوهرة",
    "المحمدية",
    "المرجان",
    "الشفا",
    "الحمدانية",
    "الصالحية",
    "البشائر",
    "الريان",
    "الكوثر",
    "الرحمانية",
    "الخمرة",
    "القرينية",
    "الفضيلة",
    "الرياض",
    "طيبة",
    "أبحر",
    "النسيم",
    "السليمانية"
  ],
  "مكة المكرمة": [
    "العزيزية",
    "النسيم",
    "العوالي",
    "الزاهر",
    "الرصيفة",
    "الشوقية",
    "العتيبية",
    "الهنداوية",
    "الطندباوي",
    "الجميزة",
    "الضيافة",
    "الحجون",
    "التقوى",
    "الخالدية",
    "المسفلة",
    "أجياد",
    "الشبيكة",
    "جرول",
    "عسفان",
    "الزايدي",
    "الشرائع",
    "الشرقي",
    "المرزوز"
  ],
  "المدينة المنورة": [
    "قباء",
    "العوالي",
    "الحرم",
    "بني ظفر",
    "السلام",
    "الروابي",
    "الفيصلية",
    "شوران",
    "العنابس",
    "الدار",
    "الأزهري",
    "النصر",
    "الرانوناء",
    "طيبة",
    "المناخة",
    "الدفاع",
    "العزيزية",
    "الخالدية",
    "الجماوات"
  ],
  "الدمام": [
    "الشاطئ",
    "البادية",
    "الفيصلية",
    "المزروعية",
    "العنود",
    "الجلوية",
    "النورس",
    "الطبيشي",
    "الريان",
    "النزهة",
    "الاتصالات",
    "المنار",
    "السوق",
    "غرناطة",
    "أحد",
    "البديع"
  ],
  "الخبر": [
    "الثقبة",
    "اليرموك",
    "قرطبة",
    "العقربية",
    "الراكة",
    "التحلية",
    "الحزام الذهبي",
    "العليا",
    "الخبر الشمالية",
    "الخبر الجنوبية",
    "البندرية",
    "الساحل",
    "الكورنيش"
  ],
  "الطائف": [
    "شهار",
    "الشرقية",
    "شبرا",
    "السلامة",
    "الحلقة",
    "النزهة",
    "المثناة",
    "قروى",
    "العزيزية",
    "الفيصلية",
    "البديع",
    "الوسام"
  ],
  "تبوك": [
    "المروج",
    "الصفاح",
    "البوادي",
    "السليمانية",
    "الورود",
    "النهضة",
    "المصيف",
    "الفيصلية",
    "العزيزية",
    "الراجحي"
  ],
  "بريدة": [
    "الصفراء",
    "الخبيب",
    "الرفيعة",
    "النقع",
    "الضاحي",
    "الإسكان",
    "النخيل",
    "الريان",
    "الشفق",
    "المنتزه",
    "الأمل",
    "الأمن",
    "الجامعيين",
    "الأفق",
    "البشر",
    "التغيرة",
    "البصيرية"
  ],
  "خميس مشيط": [
    "ضمك",
    "النسيم",
    "النزهة",
    "السد",
    "المعارض",
    "الراقي",
    "الواحة",
    "الجزيرة",
    "الشرفية",
    "السلام"
  ],
  "الجبيل": [
    "الدانة",
    "الفناتير",
    "طيبة",
    "الدفي",
    "الواحة",
    "الأحساء",
    "المرجان",
    "صناعية",
    "البحر",
    "الحويلات"
  ],
  "الاحساء": [
    "المبرز",
    "الهفوف",
    "العيون",
    "الطرف",
    "البطالية",
    "الجفر",
    "المنصورة",
    "الشعبة",
    "القارة",
    "الجشة"
  ],
  "القطيف": [
    "التوبي",
    "الشويكة",
    "الجارودية",
    "القلعة",
    "الجش",
    "المجيدية",
    "البحاري",
    "الشريعة",
    "الخويلدية",
    "النخيل"
  ],
  "حائل": [
    "المطار",
    "البدنة",
    "المزعبر",
    "السمراء",
    "النقرة",
    "المنتزه",
    "الزبارة",
    "المدينة",
    "النسيم",
    "الخزامى",
    "الفصيلية",
    "الوسيطاء",
    "العزيزية"

  ],
  "نجران": [
    "الفيصلية",
    "الفهد",
    "الأمير مشعل",
    "العريسة",
    "دحضة",
    "الشرفة",
    "القابل",
    "آل غراء",
    "رجلاء",
    "الصفا"
  ],
  "جازان": [
    "الروضة",
    "الشاطئ",
    "المطار",
    "السويس",
    "الناشفة",
    "البحر",
    "الصفا",
    "النعمي",
    "السالم",
    "النزهة",
    "الزهور",
    "الروابي",
    "النور",
    "الجبل"

  ],
  "ينبع": [
    "النخيل",
    "البحر",
    "الفيصلية",
    "النهضة",
    "البلد",
    "المروج",
    "العزيزية",
    "الصناعية",
    "النسيم",
    "الروضة"
  ],
  "أبها": [
    "السد",
    "المنهل",
    "الوردتين",
    "النزهة",
    "الضباب",
    "المروج",
    "السلام",
    "الخالدية",
    "الشرفية",
    "النسيم",
    "العرين",
    "المفاتحة",
    "الربوة",
    "المفاتحة",
    "ذرة",
    "السروات"
  ],
  "عرعر": [
    "الروضة",
    "الناصرية",
    "الفيصلية",
    "الخالدية",
    "النزهة",
    "العزيزية",
    "الصناعية",
    "المطار",
    "الريان",
    "النهضة"
  ],
  "سكاكا": [
    "النهضة",
    "الشلهوب",
    "المطار",
    "الفيصلية",
    "النزهة",
    "الملك فهد",
    "المروج",
    "السلام",
    "الصناعية",
    "العزيزية"
  ],
  "المجمعة": [
   "الملك سلمان",
   "المطار",
   "الملك فهد",
   "اليرموك",
   "الملك عبدالعزيز",
   "الملك عبدالله",
   "الفيحاء"

  ],
  "الباحة": [
   "الحاوية",
   "وسط المدينة",
   "النزهة",
   "الصفا",
   "الشفاء",
   "الشروق",
   "السلامة",
   "الباهر",
   "الظفير",
   "الأزهر",
   "الرغدان",
   "الزرقاء",
   "الشهبة"

  ],
  "تمير": [
    "الخادية",
    "العزيزية"
  ],
  "شقراء": [
   "الملك فهد",
   "الشفاء",
   "الروضة"
  ],
  "روضة سدير": [
  "الوسطي",
  "الزهرة"
  ],
  "حوطة سدير": [
   "القادسية",
   "العزيزية",
   "النهضة"
  ],
  "الزلفي": [
   "القدس",
   "اليرموك",
   "الصناعية",
   "السلام",
   "الفاروق",
   "السيح",
   "العزيزية"
  ],
  "حائط": [
   "السمراء",
   "الزبارة",
   "البرزان",
   "الخزامي",
   "المصيف",
   "الزهراء"
  ],
  "بلجرشي": [
  "المحمدية"
  ],
  "عنيزة": [
   "السلمانية",
   "الشرفية",
   "الشفا",
   "العزيزية",
   "العسيلات"
  ],
  "الليث": [
  "الشرقي",
  "المرزوز",
  "الليث"
  ],
  "جلاجل": [
   "الصناعية"

  ],
  "الغاط": [
    "حي الخزامي",
    "الصناعية",
    "الأندلس",
    "المروج",
    "البستان"

  ],
  "رياض الخبراء": [
  "الصناعية",
  "الربوة",
  "النزهة",
  "المجد"

  ],
  "القنفذة": [
    "الخالدية"

  ],
  "الرس": [
   "الحوطة",
   "اندلس",
   "جوازات"

  ],
  "المذنب": [
     "الريان",
     "الصفا",
     "الديرة"

  ],
    "البكيرية": [
    "الزهرة",
    "الهلالية",
    "الروضة",
    "النهضة"

  ],
  "البدائع": [
    "العليا",
    "التعليم",
    "الرمة",
    "النخيل"
  ],
  "عقلة الصقور": [
     "النقرة",
     "الجفن",
     "قطن"

  ],
  "عيون الجواء": [
    "المرقب",
    "الخزان",
    "المنتزة",
    "النهضة"

  ],
  "الحناكية": [
    "العقدة",
    "المخطط",
    "الزعفرانة"

  ],
  "صبيا": [
    "النهضة",
    "الربيع",
    "السعادة",
    "الفلاح"

  ],
  "بيش": [
    "الصناعية",
    "البوادي",
    "النخيل",
    "الفصيلية",
    "المروج"
  ],
  "المندق": [
   "بيدة",
   "القوارير",
   "الأطاولة",
   "قيا",
   "القرى"
  ]
};
  
  // تصدير قائمة المدن منفصلة للاستخدام المباشر
  export const citiesList = Object.keys(saudiCities);
  
  // دالة مساعدة للحصول على أحياء مدينة معينة
  export const getDistrictsForCity = (cityName) => {
    return saudiCities[cityName] || [];
  };